'use client';

import React from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

function AppLogo({
  src = '/assets/images/Untitled_design-27-1772027045051.png',
  text,
  iconName = 'SparklesIcon',
  size = 80,
  className = '',
  onClick,
}: AppLogoProps) {
  return (
    <div
      className={`flex items-center gap-2 ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={onClick}
    >
      {src ? (
        <AppImage
          src={src}
          alt="ChronoMind™"
          width={size}
          height={size}
          className="flex-shrink-0 w-auto"
          style={{ width: size, height: size, objectFit: 'contain' }}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}

      {text && <span className="text-xl font-bold">{text}</span>}
    </div>
  );
}

export default AppLogo;
